<template lang='pug'>
  v-card.elevation-0
      r-table( 
        toolbar-dense
        no-remove
        no-search 
        ref='table' 
        v-bind='tableProps' 
        @detail='submitDetail'
        @remove='submitDelete'
      )
        template( slot='items' )
          r-dialog( 
            content-class='grey lighten-3'
            no-confirm
            title='crear cuenta de banco' 
            v-model='dialogs.create'
            )
            r-form( 
              class='white'
              ref='createForm'
              submit-text='crear' 
              v-bind='createProps'
              v-model='models.create' 
              @submit='submitCreate' 
              )
          r-dialog( 
            content-class='grey lighten-3'
            no-confirm
            title='editar cuenta de banco'
            v-model='dialogs.update' 
            )
              r-form(
                class='white'
                ref='updateForm'
                submit-text='Editar Cuenta'
                v-bind='updateProps'
                v-model='models.update' 
                @submit='submitUpdate'
                )
</template>

<script>
  //
  import { RDialog, RForm, RTable } from '@/components/reusable_components/next'
  //
  import ProviderAccountBankFields from '@/views/Purchase/PchProviderAccountBank/PchProviderAccountBankFields'
  import ProviderAccountBankFilters from '@/views/Purchase/PchProviderAccountBank/PchProviderAccountBankFilters'
  import ProviderAccountBankHeaders from '@/views/Purchase/PchProviderAccountBank/PchProviderAccountBankHeaders'
  import ProviderAccountBankModel from '@/models/Purchase/PchProviderAccountBank'
  import ProviderAccountBankService from '@/services/api/purchase/PchProviderAccountBank'
  import ProviderModel from '@/models/Purchase/PchProvider'
  //
  export default {
    components: {
      RDialog,
      RForm,
      RTable,
    },
    computed: {
      /**
       * Determines ability to edit.
       * @return {boolean}  True if able to edit, False otherwise.
       */
      canEdit() {
        return this.$can('EDIT_PURCHASE_PROVIDER_BANK_ACCOUNT')
      },
      /**
       * Create form props
       * @return {Object}
       */
      createProps() {
        return {
          fields: ProviderAccountBankFields,
        }
      },
      /**
       * Table props
       * @return {Object}
       */
      tableProps() {
        return {
          noActions: !this.canEdit,
          filters: ProviderAccountBankFilters,
          headers: ProviderAccountBankHeaders,
          service: ProviderAccountBankService.toList(),
        }
      },
      /**
       * Update form props
       * @return {Object}
       */
      updateProps() {
        return {
          editable: this.canEdit,
          readOnly: !this.canEdit,
          noButtons: !this.canEdit,
          fields: ProviderAccountBankFields,
        }
      },
    },
    data() {
      return {
        dialogs: {
          create: false,
          update: false,
        },
        models: {
          create: new ProviderAccountBankModel({
            account_number: '',
            g_bank_id: '',
            g_type_account_bank_id: '',
            email: '',
            pch_provider_id: '',
          }),
          update: {
            account_number: '',
            g_bank_id: '',
            g_type_account_bank_id: '',
            email: '',
            pch_provider_id: '',
          },
        },
      }
    },
    methods: {
      /**
       * Shows the create.
       */
      showCreate() {
        this.dialogs.create = true
      },
      /**
       * Shows the create success.
       */
      showCreateSuccess() {
        this.showSuccessSnackbar('Cuenta de banco de proveedor creada exitosamente.')
        this.dialogs.create = false
      },
      /**
       * Shows the delete success.
       */
      showDeleteSuccess() {
        this.showSuccessSnackbar('Cuenta de banco de proveedor eliminada exitosamente.')
      },
      /**
       * Shows the error.
       */
      showError() {
        this.showErrorSnackbar('Ha ocurrido un error al procesar la solicitud.')
      },
      /**
       * Shows the update.
       * @param {<type>}  event   The event
       */
      showUpdate(event) {
        this.dialogs.update = true
        this.models.update = event.item
      },
      /**
       * Shows the update success.
       */
      showUpdateSuccess() {
        this.showSuccessSnackbar('Cuenta de banco de proveedor actualizada exitosamente.')
        this.dialogs.update = false
      },
      /**
       * { function_description }
       * @param      {<type>}  event   The event
       * @return     {<type>}  { description_of_the_return_value }
       */
      submitCreate(event) {
        return this
          .toCreateWait(true)
          .then(this.toCreate)
          .then(this.toCreateWait)
      },
      /**
       * { function_description }
       */
      submitDelete() {
        this.setWarningSnackbar({
          title: 'Eliminar cuenta de banco de proveedor',
          message: '¿Confirma la eliminacion de la cuenta de banco de proveedor seleccionada?',
          confirm: 'eliminar',
        })
      },
      /**
       * { function_description }
       * @param {<type>}  event   The event
       */
      submitDetail(event) {
        this.showUpdate(event)
      },
      /**
       * { function_description }
       * @param      {<type>}  event   The event
       * @return     {<type>}  { description_of_the_return_value }
       */
      submitUpdate(event) {
        return this
          .toUpdateWait(true)
          .then(this.toUpdate)
          .then(this.toUpdateWait)
      },
      /**
       * { function_description }
       * @param      {<type>}         event   The event
       * @return     {ProviderModel}  The provider model.
       */
      toCreate(event) {
        return new ProviderModel({ id: event.pch_provider_id })
          .accountBank()
          .attach({ accounts: [ event.toCreate() ] })
          .then(this.showCreateSuccess)
          .then(this.toRefresh)
          .catch(this.showError)
      },
      /**
       * { function_description }
       * @param      {boolean}  [value=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      toCreateWait(value = false) {
        return this
          .$refs
          .createForm
          .setWait(value)
      },
      /**
       * Returns a delete representation of the object.
       * @return     {<type>}  Delete representation of the object.
       */
      toDelete() {
        return this
          .models
          .update
          .delete()
          .then(this.showDeleteSuccess)
          .then(this.toRefresh)
          .catch(this.showError)
      },
      /**
       * Returns a refresh representation of the object.
       * @return     {<type>}  Refresh representation of the object.
       */
      toRefresh() {
        this
          .$refs
          .table
          .refresh()
      },
      /**
       * { function_description }
       * @param      {<type>}         event   The event
       * @return     {ProviderModel}  The provider model.
       */
      toUpdate(event) {
        return new ProviderModel({ id: event.pch_provider_id })
          .accountBank()
          .attach({ accounts: [ event.toUpdate() ] })
          .then(this.showUpdateSuccess)
          .then(this.toRefresh)
          .catch(this.showError)       
      },
      /**
       * { function_description }
       * @param      {boolean}  [value=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      toUpdateWait(value = false) {
        return this
          .$refs
          .updateForm
          .setWait(value)
      },
    },
    mounted() {
      this.setItems([
        {
          text: 'crear cuenta de banco de proveedor',
          icon: 'add_circle',
          action: this.showCreate,
        },             
      ])
    },
    beforeMount() {
      this.setTitle('Cuentas de banco de proveedores')
    },
    watch: {
      responseConfirmSnackbar(value) {
        switch(value) {
          case 'eliminar': return this.toDelete()
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      next(ctx => {
        if (!ctx.$can('VIEW_ALL_PURCHASE_PROVIDER_ACCOUNT_BANK')) ctx.$router.push('/')
      })
    },
  }
</script>